import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Paper, } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import { IoIosSearch } from "react-icons/io";
import {
    Stack,
    Pagination,
} from "@mui/material";
import { token, APIPath } from "../../config/api";
import AddZone from "./AddZone";

const StyledTableContainer = styled(TableContainer)(({ theme, open }) => ({
    marginTop: "1%",
    marginLeft: open ? theme.spacing(29) : theme.spacing(7),
    width: open ? "80%" : "94%",
    height: "100vh",
    transition: "margin-left 0.3s ease",
    background: "rgba(204,204,204,0.2)",
    padding: "1rem 1rem 1rem 1rem",
    boxShadow: "none",
}));
const StyledPaginationContainer = styled("div")({
    background: "#fff",
    margin: "2rem auto 0 auto;",
    zIndex: 1,
    background: "none",
    display: "flex",
    justifyContent: "center"
});

const ZoneList = ({ open }) => {
    const [zoneForm, setZoneForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [zoneList, setZoneList] = useState(null);
    const [searchText, setsearchText] = React.useState('');

    const getZoneList = () => {
        setIsLoading(true)
        fetch(`${APIPath}/api/v1/agency/zone`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            method: 'GET',
            mode: 'cors',
        })
            .then((res) => res.json())
            .then((data) => {
                setZoneList(data.data)
                setIsLoading(false)
            })
            .catch((err) => {
                alert(err)
                setIsLoading(false)
            })
    }

    useEffect(() => {
        getZoneList();
    }, [])
    const onClose = () => {
        setZoneForm(false);
        getZoneList();
    }
    const onShow = () => {
        setZoneForm(true)
    }
    const filterdata =zoneList && zoneList?.filter(item =>
        item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.cityName?.toLowerCase().includes(searchText.toLowerCase())
    );

    const deleteZone = (id) => {
        let confirm = window.confirm("Are you sure you want to delete this Zone?");
        if (confirm) {
            setIsLoading(true);
            fetch(`${APIPath}/api/v1/agency/zone?id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                method: 'DELETE',
                mode: 'cors',
            })
                .then((res) => res.json())
                .then((data) => {
                    alert("Zone deleted");
                    getZoneList();
                    setIsLoading(false)
                })
                .catch((err) => {
                    alert(err)
                    setIsLoading(false)
                })

        }
        else {
            setIsLoading(false);
            return
        }
    }

    const Uppercase = (str) => str.toUpperCase();
    const capitalize = (str) => {
        if (typeof str !== 'string') return '';
        return str?.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    return (
        <>
            <StyledTableContainer component={Paper} open={open}>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 20px" }}>
                    <h2 style={{ fontSize: "18px" }}>Zone</h2>
                    <button className="add-hotel"
                        onClick={onShow}
                    >Add Zone</button>
                </div>
                <div className="package-search-table" style={{ paddingBottom: "2rem" }}>
                    <div className="package-search">
                        <input type="text" placeholder="Search.."
                            value={searchText} onChange={(e) => {
                                setsearchText(e.target.value)
                            }}
                        />
                        <IoIosSearch style={{ cursor: "pointer", color: "skyblue" }} />
                    </div>
                    <div className="package-table" style={{
                        borderBottomRightRadius: "20px",
                        borderBottomLeftRadius: "20px",
                    }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Sl No.</th>
                                    <th>Zone </th>
                                    <th>City </th>
                                    <th>Country</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {isLoading ? <div className="loader"></div> :
                                <>
                                    <tbody>
                                        {filterdata?.map((val, id) => {
                                            return <>
                                                <tr key={id}>
                                                    <td>{id + 1}</td>
                                                    <td>{val.name}</td>
                                                    <td>{capitalize(val.cityName)}</td>
                                                    <td>{Uppercase(val.countryName)}</td>
                                                    {/* <td>{capitalize(val.zoneName)}</td> */}
                                                    <td> <button id="country-delete"
                                                        onClick={() => {
                                                            deleteZone(val._id)
                                                        }}
                                                    >
                                                        <img src="./deleteicon.svg" />
                                                    </button>
                                                    </td>
                                                </tr>
                                            </>
                                        })}
                                    </tbody>
                                </>}
                        </table>
                    </div>
                </div>
                {/* <StyledPaginationContainer>
                    <Stack spacing={1}>
                        <Pagination
                            count={Math.ceil((vehicleList && vehicleList?.length) / perPage)}
                            // count={1}
                            page={currentPage}
                            onChange={(event, value) => setCurrentPage(value)}
                            variant="outlined"
                            color="primary"
                            boundaryCount={1}
                        />
                    </Stack>
                </StyledPaginationContainer> */}
            </StyledTableContainer>
            {zoneForm && <AddZone onClose={onClose} onShow={onShow} getZoneList={getZoneList} />}
        </>
    );
}

export default ZoneList;
